module.exports = __webpack_public_path__ + "img/qnbfinansbank.601c5af4.png";